<template>
  <div>
    <span class="sr-only">*</span>
    <span>
      <svg
        style="vertical-align: top"
        class="hide heading-size inline-block mt-4 animate-[spin_5s_linear_infinite]"
        viewBox="0 0 75 76"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!--  Gradient Definition -->
        <defs>
          <linearGradient id="iconGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stop-color="#CE2906" />
            <stop offset="33%" stop-color="#E04A20" />
            <stop offset="66%" stop-color="#E65820" />
            <stop offset="100%" stop-color="#FF7B00" />
          </linearGradient>
        </defs>

        <!-- Apply Gradient Here -->
        <path
          fill="url(#iconGradient)"
          d="M27.668 75.939V64.59l4.073-16.005-12.513 11.64-9.894 5.529L.022 49.167l9.603-5.529L25.921 38.4 9.625 33.453.022 27.924l9.312-16.587 9.894 5.529 12.513 11.64-4.073-16.296V.861h19.206V12.21L42.8 28.506l12.513-11.64 9.894-5.529 9.312 16.587-9.604 5.529L48.62 38.4l16.296 5.238 9.604 5.529-9.313 16.587-9.894-5.529L42.8 48.585l4.074 16.005v11.349H27.666Z"
        ></path>
      </svg>
    </span>
  </div>
</template>